export const CONTACT_EMAIL = "advanceformuladigital@gmail.com";

export interface Tomo {
  emoji: string;
  n: string;
  title: string;
  subtitle: string;
  desc: string;
}

export const TOMOS: Tomo[] = [
  {
    emoji: "🍕",
    n: "TOMO 1",
    title: "PIZZA EXPRESS",
    subtitle: "El modelo de alta rotación",
    desc: "Masas, harinas, levados, salsas, combinaciones de quesos, 18 sabores, moldes, tamaños, packaging, canales de venta, costos reales del mercado argentino y simulador de ingresos.",
  },
  {
    emoji: "🎂",
    n: "TOMO 2",
    title: "PASTELERÍA DE VITRINA",
    subtitle: "Low-cost y alto margen",
    desc: "10 productos estrella con mayor margen, técnicas esenciales sin equipamiento caro, decoración, vitrina digital, toma de encargos, packaging regalo y costos reales.",
  },
  {
    emoji: "🍝",
    n: "TOMO 3",
    title: "PASTA HOUSE",
    subtitle: "Producción casera artesanal",
    desc: "Tallarines, sorrentinos, ravioles, ñoquis de papa y ricota, salsas artesanales, kit especial del 29, etiquetado con instrucciones de cocción y costos reales.",
  },
  {
    emoji: "🌾",
    n: "TOMO 4",
    title: "COCINA SIN TACC",
    subtitle: "El nicho de alta fidelización",
    desc: "Protocolo anti-contaminación cruzada, harinas certificadas, pan de molde, pizza, pastelería, pasta, empanadas y cómo comunicar el protocolo al cliente celíaco.",
  },
  {
    emoji: "👻",
    n: "TOMO 5",
    title: "GHOST KITCHEN TOP 20",
    subtitle: "Los platos más pedidos del mundo",
    desc: "Smash burgers, loaded fries, tacos street food, wok de pollo, alitas, power bowls, modelo sin local, packaging para delivery y costos reales del mercado argentino.",
  },
  {
    emoji: "💰",
    n: "TOMO 6",
    title: "BIBLIA DEL DINERO GASTRONÓMICO",
    subtitle: "Finanzas para tu cocina",
    desc: "Cálculo de costos exacto, precio de venta con margen garantizado, punto de equilibrio, simulador de ingresos, distribución de ganancias, escalamiento y plataformas de delivery.",
  },
];

export const TOMO_FEATURES = [
  "Recetas con cantidades exactas y costos reales del mercado argentino",
  "Sistema de producción por lote para maximizar el tiempo",
  "Carta lista para publicar el mismo día que lo descargás",
  "Estrategia de precios con margen real garantizado",
  "Canales de venta recomendados por rubro",
  "Checklist operativo imprimible para pegar en la cocina",
  "Planilla financiera específica del rubro",
  "Contexto 100% adaptado al emprendedor argentino",
];

export interface Bono {
  num: string;
  title: string;
  desc: string;
  price: string;
}

export const BONOS: Bono[] = [
  {
    num: "01",
    title: "Recetario Express de Salsas Rentables",
    desc: "35+ salsas para diferenciar cualquier producto, aumentar el ticket y vender como extra en cada pedido.",
    price: "$8.000 ARS",
  },
  {
    num: "02",
    title: "Los 37 Secretos de Cocina Profesional",
    desc: "Los trucos técnicos que hacen que tu comida se vea, huela y sepa como si saliera de un local profesional.",
    price: "$9.000 ARS",
  },
  {
    num: "03",
    title: "Menú 72HS: Cartas Listas para Vender",
    desc: "6 cartas completas por rubro para copiar, completar con tus precios y publicar hoy mismo.",
    price: "$8.000 ARS",
  },
  {
    num: "04",
    title: "Pack de Combos Ganadores",
    desc: "44 combos listos con textos para copiar que aumentan el ticket promedio entre 30% y 60% sin conseguir nuevos clientes.",
    price: "$9.000 ARS",
  },
  {
    num: "05",
    title: "Checklist de Producción Sin Caos",
    desc: "El sistema completo para producir como negocio organizado: mise en place, producción, empaque, entrega y cierre semanal.",
    price: "$8.000 ARS",
  },
  {
    num: "06",
    title: "Scripts de WhatsApp para Vender Comida",
    desc: "60+ mensajes listos para copiar, pegar y cerrar pedidos como un negocio profesional aunque estés vendiendo desde tu cocina.",
    price: "$9.000 ARS",
  },
];

export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  product: string;
  quote: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    initials: "MR",
    name: "Marcela R.",
    location: "Gran Buenos Aires",
    product: "Megapack 72hs™",
    quote:
      "Empecé a vender pizzas el jueves. El viernes ya tenía 8 pedidos con seña. El simulador de costos me salvó de trabajar gratis sin darme cuenta.",
  },
  {
    initials: "JP",
    name: "Juan P.",
    location: "Córdoba",
    product: "Megapack Maestro PRO",
    quote:
      "El Tomo de Ghost Kitchen me dio exactamente lo que necesitaba. El Kit de Marca cambió cómo me perciben mis clientes desde el primer día.",
  },
  {
    initials: "SV",
    name: "Sofía V.",
    location: "Rosario",
    product: "Megapack 72hs™",
    quote:
      "Los scripts de WhatsApp son lo mejor del pack. Antes no sabía cómo pedir la seña. Ahora lo hago con total naturalidad y casi todos confirman.",
  },
  {
    initials: "CR",
    name: "Carolina R.",
    location: "Mendoza",
    product: "Megapack Maestro PRO",
    quote:
      "Los 30 días de contenido para Instagram me cambiaron todo. Empecé a publicar todos los días y los pedidos se triplicaron en un mes.",
  },
  {
    initials: "DM",
    name: "Diego M.",
    location: "Neuquén",
    product: "Megapack 72hs™",
    quote:
      "El Checklist de Producción me organizó la cocina entera. Ya no se me mezclan pedidos ni me olvido insumos a mitad de la producción.",
  },
  {
    initials: "LF",
    name: "Lucía F.",
    location: "La Plata",
    product: "Megapack 72hs™",
    quote:
      "Tengo celíacos en la familia y nunca había podido vender Sin TACC con confianza. El Tomo 4 me dio el protocolo completo para hacerlo bien.",
  },
];

export const PAIN_POINTS = [
  "Semana tras semana buscando recetas rentables que nunca terminan de cerrar para el mercado argentino",
  "Precios calculados a ojo sin saber si estás ganando o perdiendo plata de verdad",
  "Clientes que preguntan por WhatsApp y no sabés qué responder ni cómo cobrar la seña sin vergüenza",
  "Producción caótica donde se mezclan pedidos, se olvidan ingredientes y se entrega tarde",
  "Fotos que no generan pedidos porque no sabés cómo fotografiar comida con el celular",
  "Semana terminada, sin haber vendido nada, y el ciclo vuelve a empezar el lunes",
];

export interface KitRow {
  situation: string;
  without: string;
  with: string;
}

export const KIT_ROWS: KitRow[] = [
  {
    situation: "Tus productos no tienen identidad visual",
    without: "Cada post parece diferente y sin marca",
    with: "Manual de Marca Food Casera listo para aplicar",
  },
  {
    situation: "No sabés qué publicar en Instagram",
    without: "Publicás cuando se te ocurre algo",
    with: "30 días de contenido planificado y listo",
  },
  {
    situation: "Querés subir precios pero tenés miedo de perder clientes",
    without: "Bajás precio para competir y perdés margen",
    with: "Guía del Precio Premium con script de comunicación",
  },
  {
    situation: "Tus clientes compran una vez y no vuelven",
    without: "No tenés sistema de seguimiento ni fidelización",
    with: "Kit de Recompra con sistema de sellos activo",
  },
  {
    situation: "Querés sumar un segundo rubro pero no sabés cuándo",
    without: "Expandís demasiado rápido y todo se cae",
    with: "Protocolo de Crecimiento con criterios exactos",
  },
  {
    situation: "Rappi y PedidosYa te generan dudas",
    without: "No sabés si conviene entrar o no",
    with: "Guía de Plataformas con análisis real de margen",
  },
  {
    situation: "No sabés cuándo podés contratar ayuda",
    without: "Seguís solo hasta agotarte completamente",
    with: "Calculadora del Primer Empleado",
  },
  {
    situation: "No proyectás ingresos a futuro",
    without: "Vivís semana a semana sin rumbo",
    with: "Plan de Negocios a 12 meses completo",
  },
];

export const KIT_INCLUDES = [
  { title: "Manual de Marca Food Casera", desc: "Nombre, paleta de colores, logo y voz de marca" },
  { title: "Sistema 30/30", desc: "30 días de contenido planificado para Instagram" },
  { title: "Guía del Precio Premium", desc: "Cómo subir márgenes sin perder clientes" },
  { title: "Kit de Recompra y Fidelización", desc: "Sistema de sellos, encuesta y reactivación" },
  { title: "Protocolo de Crecimiento", desc: "Cuándo y cómo expandirse sin caos" },
  { title: "Guía Maestra de Plataformas", desc: "Rappi, PedidosYa, MercadoShops, Shopify" },
  { title: "Calculadora del Primer Empleado", desc: "Cuándo, a quién y cómo contratar" },
  { title: "Plan de Negocios a 12 Meses", desc: "El mapa financiero completo del negocio" },
];

export interface Faq {
  q: string;
  a: string;
}

export const FAQS: Faq[] = [
  {
    q: "¿Necesito experiencia previa en cocina?",
    a: "No. El sistema está diseñado para funcionar con habilidades básicas de cocina. Las recetas tienen instrucciones paso a paso y el Bono 2 cubre todos los secretos técnicos que necesitás saber antes de empezar a producir.",
  },
  {
    q: "¿Cuánto capital necesito para empezar?",
    a: "Depende del rubro que elijas. En el Tomo 6 hay una tabla de inversión inicial por rubro. Pizza y pastelería básica pueden arrancarse con menos de $15.000 en insumos. El Ghost Kitchen requiere algo más de inversión inicial.",
  },
  {
    q: "¿Cómo recibo el material?",
    a: "Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF. Sin apps, sin plataformas, sin contraseñas que vencen. Tuyo para siempre, para usar cuando quieras.",
  },
  {
    q: "¿Sirve para cualquier parte de Argentina?",
    a: "Sí. Los costos están expresados en porcentajes y con referencia al mercado argentino en general. Cada persona ajusta el precio final según los valores de su zona.",
  },
  {
    q: "¿Tiene garantía real?",
    a: "Sí. 7 días. Devolución del 100%. Sin preguntas ni formularios. Un mail a advanceformuladigital@gmail.com y listo.",
  },
];

export interface CostRow {
  action: string;
  cost: string;
}

export const COST_ROWS: CostRow[] = [
  { action: "Semanas buscando recetas rentables en internet", cost: "Tiempo que podría ser dinero en tu bolsillo" },
  { action: "Vender sin calcular costos correctamente", cost: "Trabajar gratis sin saberlo" },
  { action: "No saber cómo cerrar pedidos por WhatsApp", cost: "Clientes que preguntan y se van sin comprar" },
  { action: "Producir sin sistema ni organización", cost: "Caos, errores, entregas tarde y agotamiento" },
  { action: "No tener carta ni identidad visual", cost: "Parecer improvisado y perder la confianza del cliente" },
  { action: "Seguir esperando el momento perfecto", cost: "El mismo punto de partida dentro de 6 meses" },
];